var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWaves = function SvgWaves(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1470 1427"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 3,
    d: "M1281.5 1011.8c346.7-142.8 149.3-457.2-100.4-601-139.7-88.5-64.4-276.2-237.6-385.7C770.3-84.5 738.6 232.6 468.9 68.6 199.2-95.3-110.6 327.3 42.8 534.4c153.4 207.2 43 203.2 47.8 525.7 4.8 322.4 483.8 500.3 642.3 240.7s173.3-134.5 548.6-289Z",
    className: "w1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 3,
    d: "M1231.8 986.5c318.2-130.8 139.8-423.6-91.3-556.1-130.8-82.1-63.6-256.5-223.2-357.4-163.1-103.2-191.5 187.6-440.6 38C226.7-38.8-63 349.5 81.5 544c143.4 193.5 39.4 190.3 45.7 488.2 6.2 297.9 447 462.6 596 222.6 146-237.5 162.2-126 508.6-268.4Z",
    className: "w2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 3,
    d: "M1182 961.3c290-119 130.4-390.2-82.1-511.4-121.9-75.7-62.7-236.7-208.7-329C738 23.8 713 288.4 484.5 153.2 254.2 17.8-15.1 371.6 120.2 553.8c133.5 179.8 35.8 177.4 43.5 450.7 7.8 273.3 410.3 424.8 550 204.6 133.4-215.4 151-117.7 468.3-247.8Z",
    className: "w3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 3,
    d: "M1132.3 936c261.5-107 120.9-356.6-73-466.5-113-69.3-61.8-217-194.3-300.8-143.2-90.5-164.8 147.8-372.8 27C281.8 74.2 32.6 393.7 159 563.3c123.5 166.4 32 164.7 41.3 413.4 9.2 248.8 373.5 387 503.8 186.5C825 970 843.9 1054 1132.3 936.1Z",
    className: "w4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 3,
    d: "M1082.6 910.8c233-95.2 111.4-323.1-64-421.8-104-62.9-60.8-197.2-179.8-272.4-133.1-84.2-151.5 128-338.8 21.3C309.3 131 80.4 416 197.6 573.1c113.7 152.6 28.6 151.7 39.2 375.9 10.7 224.2 336.8 349.2 457.7 168.4 108.4-171 128.6-101 388.1-206.6Z",
    className: "w5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 3,
    d: "M1032 886.3c204.6-83.3 101.8-289.6-55-377-95-56.5-60-177.4-165.3-244-123.2-78-138.1 108-304.9 15.7-171-92.9-379.6 158-271.5 302.5 103.8 139 25 138.8 37.1 338.4 12.2 199.7 300 311.4 411.5 150.4 95.9-149 117.4-92.6 348-186Z",
    className: "w6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 3,
    d: "M980.1 862.7c176.3-71.4 92.5-256.1-45.7-332.2-86.1-50.1-59.1-157.7-151-215.8-113-71.6-124.6 88.3-270.8 10.3C361.3 246.3 172.8 462.7 272 594.8c94 125.3 21.4 125.9 35 301 13.6 175 263.2 273.6 365.3 132.2 83.4-126.8 106.2-84.1 308-165.3Z",
    className: "w7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 3,
    d: "M928.3 839.1c147.8-59.5 83-222.6-36.7-287.4-77.2-43.7-58.2-138-136.5-187.5-103.2-65.2-111.4 68.3-237 4.7-131.4-64.4-299.7 117.6-209.6 237.2 84 111.7 17.8 113 32.8 263.6 15 150.5 226.5 235.8 319.2 114.1 70.8-104.6 95-75.7 267.8-144.7Z",
    className: "w8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 3,
    d: "M876.3 815.6C995.7 768 949.8 626.5 848.8 573c-68.3-37.3-57.4-118.2-122-159.1-93.3-59-98.1 48.4-203-1-111.8-50.1-260 97.7-178.8 204.7 74 98 14.1 100.1 30.6 226.1s189.7 198 273 96.1c58.3-82.5 83.9-67.4 227.7-124Z",
    className: "w9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 3,
    d: "M824.2 792.2c91-35.7 64-155.6-18.4-197.9-59.4-30.8-56.5-98.4-107.6-130.7-83.2-52.6-84.7 28.5-169-6.5-92.1-36-219.9 77.4-147.9 171.9 64.1 84.4 10.5 87.3 28.5 188.7s153 160.2 226.9 78c45.7-60.4 72.6-59 187.5-103.5Z",
    className: "w10"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 3,
    d: "M771.9 769c62.6-23.9 54.5-122.1-9.3-153.1-50.4-24.5-55.6-78.7-93.2-102.5-73.2-46.2-71.3 8.7-135-12-72.3-21.8-180 57.2-117 139.2 54.3 70.8 7 74.4 26.4 151.3s116.2 122.4 180.7 60c33.2-38.3 61.4-50.7 147.4-83Z",
    className: "w11"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 3,
    d: "M719.3 746c34.2-12 45-88.7-.2-108.4-41.5-18-54.7-59-78.7-74.1-63.2-40-58-11.2-101.2-17.5-52.5-7.7-139.9 37-86 106.5 44.3 57 3.3 61.5 24.2 113.8 21 52.3 79.5 84.6 134.6 41.9 20.7-16 50.2-42.2 107.3-62.2Z",
    className: "w12"
  })));
};
export default SvgWaves;